/* ----------------------------------------
    App Configuration
---------------------------------------- */

const config = {
    new: {
        applicant: {
            number: 1,
            title: 'apply_group_1_title',
            startStep: 'intro',
            totalProgress: 8,
            steps: {
                intro: {
                    progress: 0,
                },
                aanvrager: {
                    progress: 1,
                },
                kiesOrganisatie: {
                    progress: 2,
                    skip: {
                        noOrganisations: 'applicant/vind-organisatie',
                    },
                },
                vindOrganisatie: {
                    progress: 2,
                },
                maakOrganisatie: {
                    progress: 2,
                },
                communityToegestaan: {
                    progress: 2,
                },
                communityAfgewezen: {
                    progress: 2,
                },
                maakCommunity: {
                    progress: 2,
                },
            }
        },
    },
    edit: {
        applicant: {
            number: 1,
            title: 'apply_group_1_title',
            startStep: 'intro',
            totalProgress: 8,
            steps: {
                kvk: {
                    progress: 3,
                    skip: {
                        isCommunity: 'applicant/add-contact-question',
                        isNoAdminAndValueIsSet: ['organisation.kvk', 'applicant/tekenbevoegd-vereist'],
                    },
                },
                tekenbevoegdVereist: {
                    progress: 4,
                    skip: {
                        isCommunity: 'applicant/add-contact-question',
                        isNoAdmin: 'applicant/add-contact-question',
                    },
                },
                tekenbevoegdVraag: {
                    progress: 4,
                    skip: {
                        isCommunity: 'applicant/add-contact-question',
                        isNoAdmin: 'applicant/add-contact-question',
                        noAuthorizedToSignRequired: 'applicant/add-contact-question',
                    },
                },
                tekenbevoegd: {
                    progress: 4,
                    skipOnPrev: true,
                    skip: {
                        isNoAdmin: 'applicant/add-contact-question',
                        noAuthorizedToSignRequired: 'applicant/add-contact-question',
                    },
                },
                addContactQuestion: {
                    progress: 5,
                },
                addContact: {
                    progress: 5,
                    skipOnPrev: true,
                },
                statutenVereist: {
                    progress: 6,
                    skip: {
                        isCommunity: 'project/aanvang',
                        isNoAdminAndFileIsSet: ['organisation', 'statuten', 'applicant/jaarrekening'],
                    },
                },
                statuten: {
                    progress: 6,
                    skip: {
                        isCommunity: 'project/aanvang',
                        statutenExists: 'project/aanvang',
                        organizationNotInFormation: 'applicant/jaarrekening',
                        isNoAdminAndFileIsSet: ['organisation', 'statuten', 'applicant/jaarrekening'],
                    },
                },
                jaarrekening: {
                    progress: 7,
                    skip: {
                        isCommunity: 'project/aanvang',
                        organizationInFormation: 'project/aanvang',
                        isNoAdminAndFileIsSet: ['organisation', 'jaarrekening', 'project/aanvang'],
                    },
                },
            }
        },
        project: {
            number: 2,
            title: 'apply_group_2_title',
            startStep: 'aanvang',
            totalProgress: 5,
            steps: {
                aanvang: {
                    progress: 0,
                },
                crowdfunding: {
                    progress: 0,
                    skip: {
                        starting_date_valid: 'project/projectplan',
                    }
                },
                declined: {
                    progress: 0,
                    skipOnPrev: true,
                },
                projectplan: {
                    progress: 1,
                },
                begroting: {
                    progress: 2,
                },
                offertes: {
                    progress: 3,
                },
                bedrag: {
                    progress: 4,
                },
            }
        },
        confirmation: {
            number: 3,
            title: 'apply_group_3_title',
            startStep: 'bevestig',
            totalProgress: 1,
            steps: {
                bevestig: { 
                    progress: 0,
                },
                klaar: { 
                    progress: 1,
                },
            }
        },
    }
};

/* ----------------------------------------
    Export Module
---------------------------------------- */

module.exports = {
    config
};